import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getTransferCompanyList,
	addNewTransferCompany,
	updateTransferCompany,
	deleteTransferCompany,
	getTransferCompany,
	existsTransferCompany,
} from '../transferCompany/thunk';

export const initialState = {
	itemTransferCompanyList: [],
	itemTransferCompanyDetail: null,
	isTransferCompanyLoading: false,
	isTransferCompanySuccess: false,

	transferCompanyList: [],
	transferCompanyListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const TransferCompanySlice = createSlice({
	name: 'TransferCompanies',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getTransferCompany.fulfilled, (state, action) => {
			state.isTransferCompanyLoading = false;
			state.isTransferCompanySuccess = true;
			state.itemTransferCompanyDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getTransferCompany.pending, state => {
			state.isTransferCompanyLoading = true;
			state.isTransferCompanySuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferCompany.rejected, (state, action) => {
			state.isTransferCompanyLoading = false;
			state.isTransferCompanySuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getTransferCompanyList.pending, state => {
			state.isTransferCompanySuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferCompanyList.fulfilled, (state, action) => {
			state.itemTransferCompanyList = action.payload;
			state.transferCompanyList = action.payload;
			state.isLoadingList = false;
			state.isTransferCompanySuccess = true;

			let transferCompanyListSelect = [];
			action.payload.map(item =>
				transferCompanyListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.transferCompanyListSelect = transferCompanyListSelect;
		});
		builder.addCase(getTransferCompanyList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isTransferCompanySuccess = true;
		});
		builder.addCase(addNewTransferCompany.fulfilled, (state, action) => {
			state.itemTransferCompanyList.push(action.payload);
			state.transferCompanyList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewTransferCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewTransferCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateTransferCompany.fulfilled, (state, action) => {
			state.itemTransferCompanyList = state.itemTransferCompanyList.map(transferCompany =>
				transferCompany.transferCompanyname === action.payload.old_transferCompany
					? { ...transferCompany, ...action.payload.updated_transferCompany }
					: transferCompany
			);
			state.transferCompanyList = state.transferCompanyList.map(transferCompany =>
				transferCompany._id.toString() === action.payload._id.toString()
					? { ...transferCompany, ...action.payload }
					: transferCompany
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateTransferCompany.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateTransferCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteTransferCompany.fulfilled, (state, action) => {
			state.itemTransferCompanyList = current(state.itemTransferCompanyList).filter(
				item => item._id !== action.payload._id
			);
			state.transferCompanyList = current(state.transferCompanyList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteTransferCompany.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteTransferCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		}); 

		builder.addCase(existsTransferCompany.fulfilled, (state, action) => {
			state.exists = false;
			if (action.payload === true)
				state.exists = true;
		});
		builder.addCase(existsTransferCompany.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(existsTransferCompany.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = TransferCompanySlice.actions;

export default TransferCompanySlice.reducer;